module.exports = __webpack_public_path__ + "static/media/didi_playing_baja01.3ae7c04f.png";